import type { SpriteDefinition } from '@/render/spriteBaker';
import { PALETTE } from '@/sprites/palette';

/**
 * Furniture and animals.
 *
 * Everything here is a silhouette drawn over a floor or ground tile, so all of
 * it uses transparency and none of it tiles.
 */

const TABLE = [
  '................',
  '................',
  '..MMMMMMMMMMMM..',
  '..MffffffffffM..',
  '..MffffffffffM..',
  '..MffffffffffM..',
  '..MffffffffffM..',
  '..MMMMMMMMMMMM..',
  '...M........M...',
  '...M........M...',
  '...M........M...',
  '...MM......MM...',
  '................',
  '................',
  '................',
  '................',
];

const CHAIR = [
  '................',
  '................',
  '....MMMMMMMM....',
  '....MffffffM....',
  '....MffffffM....',
  '....MffffffM....',
  '....MMMMMMMM....',
  '....MffffffM....',
  '....MffffffM....',
  '....MMMMMMMM....',
  '.....M....M.....',
  '.....M....M.....',
  '................',
  '................',
  '................',
  '................',
];

const LAMP = [
  '................',
  '.....WWWWWW.....',
  '....WWWWWWWW....',
  '...WWWWWWWWWW...',
  '...WWWWWWWWWW...',
  '....WWWWWWWW....',
  '......MMMM......',
  '.......MM.......',
  '.......MM.......',
  '.......MM.......',
  '.......MM.......',
  '.....MMMMMM.....',
  '....MMMMMMMM....',
  '................',
  '................',
  '................',
];

const PLANT_POT = [
  '................',
  '.......l........',
  '......lLl.l.....',
  '.....llLLlLl....',
  '....llLLLLLl....',
  '.....lLLLLl.....',
  '......lLLl......',
  '.......LL.......',
  '.....qqqqqq.....',
  '.....qQQQQq.....',
  '.....qQQQQq.....',
  '......QQQQ......',
  '......QQQQ......',
  '.......QQ.......',
  '................',
  '................',
];

const BOOKSHELF = [
  '..MMMMMMMMMMMM..',
  '..MffffffffffM..',
  '..MzzuuzzuuzzM..',
  '..MzzuuzzuuzzM..',
  '..MffffffffffM..',
  '..MuuzzuuzzuuM..',
  '..MuuzzuuzzuuM..',
  '..MffffffffffM..',
  '..MzzuuzzuuzzM..',
  '..MzzuuzzuuzzM..',
  '..MffffffffffM..',
  '..MMMMMMMMMMMM..',
  '................',
  '................',
  '................',
  '................',
];

const CHICKEN = [
  '................',
  '................',
  '................',
  '................',
  '.......WW.......',
  '......WWWW......',
  '.....WWeWWz.....',
  '.....WWWWWW.....',
  '....WWWWWWWW....',
  '...WWWWWWWWWW...',
  '...WWWWWWWWWW...',
  '....WWWWWWWW....',
  '.....WW..WW.....',
  '.....cc..cc.....',
  '................',
  '................',
];

const CHICKEN_PECK = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '......WWWW......',
  '.....WWWWWW.....',
  '....WWeWWWWz....',
  '....WWWWWWWW....',
  '...WWWWWWWWWW...',
  '...WWWWWWWWWW...',
  '....WWWWWWWW....',
  '.....WW..WW.....',
  '.....cc..cc.....',
  '................',
  '................',
];

const EGG = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '.......WW.......',
  '......WWWW......',
  '......WWWW......',
  '......WWWW......',
  '.......WW.......',
  '................',
  '................',
  '................',
];

const FEED_TROUGH = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '..MMMMMMMMMMMM..',
  '..MiiiiiiiiiiM..',
  '..MiIIiiIIiiiM..',
  '..MiiiiiiiiiiM..',
  '..MMMMMMMMMMMM..',
  '...M........M...',
  '................',
  '................',
  '................',
  '................',
];

export const FURNITURE_SPRITES = {
  table: { name: 'furniture-table', rows: TABLE, palette: PALETTE },
  chair: { name: 'furniture-chair', rows: CHAIR, palette: PALETTE },
  lamp: { name: 'furniture-lamp', rows: LAMP, palette: PALETTE },
  plantPot: { name: 'furniture-plant-pot', rows: PLANT_POT, palette: PALETTE },
  bookshelf: { name: 'furniture-bookshelf', rows: BOOKSHELF, palette: PALETTE },
  chicken: { name: 'animal-chicken', rows: CHICKEN, palette: PALETTE },
  chickenPeck: { name: 'animal-chicken-peck', rows: CHICKEN_PECK, palette: PALETTE },
  egg: { name: 'prop-egg', rows: EGG, palette: PALETTE },
  trough: { name: 'prop-trough', rows: FEED_TROUGH, palette: PALETTE },
} as const satisfies Record<string, SpriteDefinition>;

export type FurnitureSpriteKey = keyof typeof FURNITURE_SPRITES;
